import { render } from "./CompaniesManager.vue?vue&type=template&id=484194cc"
import script from "./CompaniesManager.vue?vue&type=script&lang=js"
export * from "./CompaniesManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__